import React, { useState } from "react";
import { useSelector } from "react-redux";
import axios from "../../../config";
import { makeStyles } from "@material-ui/core/styles";

import { LinearProgress } from "@material-ui/core";
import MembersTable from "./MembersTable";
import SelectableItem from "./utility/SelectableItem";

const useStyles = makeStyles((theme) => ({
    
    backButton: {
      backgroundColor: "#f7c948",
      boxShadow: "0px 3px 6px #00000029",
      padding: "1vh 1vw",
      outline: "none",
      textDecoration: "none",
      border: "none",
      borderRadius: "6px",
      color: "white",
      marginBottom: "1%"
    },
  }));
const Members = () => {
  const classes = useStyles();

  const [loading, setLoading] = useState({
    space: false,
    member: false,
  });
  const [spaces, setSpaces] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState("");
  const [selectedSpace, setSelectedSpace] = useState("");
  const orgs = useSelector((state) => state.sync.orgs);
  const orgOptions =
    orgs.length > 0
      ? orgs.map((org) => {
          return (
            <option key={org.org_id} value={org.org_id}>
              {org.name}
            </option>
          );
        })
      : null;

  const changeOrganisation = (e) => {
    const org = e.target.value;
    setSelectedOrg(org);
    getSpaces(org);
  };

  const changeSpace = (val) => {
    setSelectedSpace(val.value);
  };

  const getSpaces = async (orgId) => {
    try {
      setLoading({
        ...loading,
        space: true,
      });
      let res = await axios.get(`/sync/podio/audit/spaces?org_id=${orgId}`);
      setSpaces(res.data);
      setLoading({
        ...loading,
        space: false,
      });
    } catch (e) {
      setLoading({
        ...loading,
        space: false,
      });
    }
  };

  const spaceOptions =
    spaces.length > 0
      ? spaces.map((space) => {
          return {
            label: `${space.space_name}`,
            value: space.space_id,
          };
        })
      : [];

      const handleBackButtonClick = () => {
        window.history.back();
      };
    

  return (
    <div>
      <div className="">
        <div>
          <button
            onClick={handleBackButtonClick}
            className={classes.backButton}
          >
            Back
          </button>
        </div>
        <h5 className="mb-4">Workspace Members</h5>
        <p>
          To access workspace members, select an organization and the workspace
        </p>
        <div className="row">
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="org">Select Organization</label>
                  <select
                    className="form-control"
                    value={selectedOrg}
                    onChange={changeOrganisation}
                    style={{ height: "52px" }}
                  >
                    <option selected>Select An Organization</option>
                    {orgOptions}
                  </select>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="space">Select Workspace</label>
                  <SelectableItem
                    placeholder="Select a Space"
                    options={spaceOptions}
                    handleChange={changeSpace}
                    isMulti={false}
                  />
                </div>
                {loading.space ? <LinearProgress className="mb-4" /> : null}
              </div>
            </div>
          </div>
        </div>

        {selectedSpace ? <MembersTable spaceId={selectedSpace} /> : null}
      </div>
    </div>
  );
};

export default Members;
